/* =========================================================
   QUBITHEME — Cart & Drawer JS
   Shopify Cart AJAX API integration with slide-in Drawer.
   ========================================================= */

// === UPDATE CART BADGE COUNTS ===
function updateCartBadges() {
  var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) ? window.theme.routes.cart_url + '.js' : '/cart.js';
  fetch(cartUrl)
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var count = cart.item_count;
      var badges = document.querySelectorAll('.js-cart-count');
      badges.forEach(function(badge) { badge.innerText = count; });
    })
    .catch(function() {});
}

// === TOGGLE CART DRAWER ===
function toggleCartDrawer(isOpen) {
  var drawer = document.getElementById('cart-drawer');
  var backdrop = document.querySelector('.cart-drawer-backdrop');
  if (!drawer || !backdrop) return;

  if (isOpen) {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden'; // Prevent page scrolling
    refreshCartDrawer();
  } else {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  }
}

// === REFRESH DRAWER HTML (Section Rendering API via Header) ===
function refreshCartDrawer() {
  var drawerContainer = document.getElementById('cart-drawer');
  if (!drawerContainer) return;

  var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) ? window.theme.routes.root_url : '';
  var sectionUrl = (rootUrl === '/' ? '' : rootUrl) + '/?sections=header';

  fetch(sectionUrl)
    .then(function(r) { return r.json(); })
    .then(function(sections) {
      var html = sections['header'];
      if (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newInner = doc.querySelector('.cart-drawer__inner');
        if (newInner) {
          drawerContainer.innerHTML = '';
          drawerContainer.appendChild(newInner);
          loadDrawerRecommendations();
        }
      }
    })
    .catch(function(err) {
      console.error('Error refreshing cart drawer:', err);
    });
}

// === UPDATE ITEM QUANTITY FROM DRAWER ===
function updateDrawerItemQty(lineKey, quantity) {
  var drawerContent = document.querySelector('.cart-drawer__content');
  if (drawerContent) drawerContent.style.opacity = '0.5';

  var changeUrl = (window.theme && window.theme.routes && window.theme.routes.cart_change_url) || '/cart/change.js';
  if (!changeUrl.endsWith('.js')) changeUrl += '.js';

  fetch(changeUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: quantity
    })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    updateCartBadges();
    refreshCartDrawer();
  })
  .catch(function(err) {
    console.error('Error changing item quantity:', err);
    refreshCartDrawer();
  });
}

// === REMOVE ITEM FROM DRAWER ===
function removeDrawerItem(lineKey) {
  updateDrawerItemQty(lineKey, 0);
}

// === SAVE GIFT NOTE TO CART ATTRIBUTES ===
function saveCartDrawerNote(note) {
  var updateUrl = (window.theme && window.theme.routes && window.theme.routes.cart_update_url) || '/cart/update.js';
  if (!updateUrl.endsWith('.js')) updateUrl += '.js';

  fetch(updateUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ note: note })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    console.log('Cart note updated successfully.');
  })
  .catch(function(err) {
    console.error('Error updating cart note:', err);
  });
}

// === DYNAMIC RECOMMENDATIONS IN DRAWER ===
function loadDrawerRecommendations() {
  var recSection = document.querySelector('.cart-drawer__recommendations-section');
  var recContainer = document.getElementById('drawer-recommendations-container');
  if (!recSection || !recContainer) return;

  var url = recSection.dataset.recommendationsUrl;
  if (!url) return;

  fetch(url)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var products = data.products || [];
      if (products.length === 0) {
        recSection.style.display = 'none';
        return;
      }

      var html = '';
      products.forEach(function(product) {
        var firstVariant = product.variants[0];
        if (!firstVariant) return;

        // Format money simple replacement (assuming Euros format)
        var priceFormatted = '€' + (product.price / 100).toFixed(2).replace('.', ',');

        html += 
          '<div class="drawer-recommend-card">' +
            '<img class="drawer-recommend-card__thumb" src="' + product.featured_image + '" alt="' + product.title + '">' +
            '<div class="drawer-recommend-card__info">' +
              '<h5 class="drawer-recommend-card__title">' + product.title + '</h5>' +
              '<span class="drawer-recommend-card__price">' + priceFormatted + '</span>' +
            '</div>' +
            '<button type="button" class="drawer-recommend-card__btn" onclick="addRecommendToCart(' + firstVariant.id + ')">' +
              'Aggiungi' +
            '</button>' +
          '</div>';
      });

      recContainer.innerHTML = html;
    })
    .catch(function(err) {
      console.error('Error loading recommendations in drawer:', err);
      recSection.style.display = 'none';
    });
}

// === ADD RECOMMENDATION ITEM TO CART ===
function addRecommendToCart(variantId) {
  var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
  if (!addUrl.endsWith('.js')) addUrl += '.js';

  fetch(addUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      items: [{ id: parseInt(variantId, 10), quantity: 1 }]
    })
  })
  .then(function(r) {
    if (!r.ok) throw new Error('Error adding recommendation');
    return r.json();
  })
  .then(function(data) {
    updateCartBadges();
    refreshCartDrawer();
  })
  .catch(function(err) {
    console.error(err);
  });
}

// === QUICK ADD TO CART (Product Card ATC) ===
function quickAddToCart(button) {
  var variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;

  var originalHTML = button.innerHTML;
  button.innerHTML = '...';
  button.disabled = true;

  var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
  if (!addUrl.endsWith('.js')) addUrl += '.js';

  fetch(addUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      items: [{ id: parseInt(variantId, 10), quantity: 1 }]
    })
  })
  .then(function(r) {
    if (!r.ok) throw new Error('Error');
    return r.json();
  })
  .then(function(data) {
    updateCartBadges();
    button.innerHTML = originalHTML;
    button.disabled = false;
    // Open drawer immediately
    toggleCartDrawer(true);
  })
  .catch(function(err) {
    button.innerHTML = (window.theme && window.theme.strings && window.theme.strings.error) || 'Errore';
    setTimeout(function() {
      button.innerHTML = originalHTML;
      button.disabled = false;
    }, 2000);
  });
}

// === INITIALIZE EVENTS ===
document.addEventListener('DOMContentLoaded', function() {
  updateCartBadges();

  // 1. Delegated Quick Add to Cart handler (only for direct-add buttons, not links for products with variants)
  document.addEventListener('click', function(e) {
    var atcBtn = e.target.closest('button.product-card__atc-btn');
    if (atcBtn && atcBtn.getAttribute('data-variant-id')) {
      e.preventDefault();
      e.stopPropagation();
      quickAddToCart(atcBtn);
    }
  });

  // 2. Intercept all standard product form submissions
  document.addEventListener('submit', function(e) {
    var productForm = e.target.closest('form[action*="/cart/add"]');
    if (productForm) {
      e.preventDefault();

      var submitBtn = productForm.querySelector('[type="submit"]');
      var originalBtnText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = (window.theme && window.theme.strings && window.theme.strings.adding) || 'Aggiunta...';
      }

      var formData = new FormData(productForm);
      var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
      if (!addUrl.endsWith('.js')) addUrl += '.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Error adding to cart');
        return r.json();
      })
      .then(function(data) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalBtnText;
        }
        updateCartBadges();
        toggleCartDrawer(true);
      })
      .catch(function(err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = (window.theme && window.theme.strings && window.theme.strings.error) || 'Errore';
          setTimeout(function() {
            submitBtn.textContent = originalBtnText;
          }, 2000);
        }
        console.error('Error submitting product form:', err);
      });
    }
  });
});

window.addEventListener('storage', function() {
  updateCartBadges();
  // Sync drawer if open in other window
  var drawer = document.getElementById('cart-drawer');
  if (drawer && drawer.classList.contains('is-open')) {
    refreshCartDrawer();
  }
});

// === CHECKOUT AGREEMENT VALIDATION & DISCOUNT CODE PROPAGATION ===
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    var checkoutBtn = e.target.closest('a[href^="/checkout"], a[href*="checkout"]');
    if (!checkoutBtn) return;

    // Se un codice sconto è memorizzato in sessione (es. da lookbook bundle), propagalo nell'URL di checkout
    var discountCode = sessionStorage.getItem('shopify_discount_code');
    if (!discountCode) {
      var cartDiscountEl = document.querySelector('[data-active-discount-code]');
      if (cartDiscountEl) discountCode = cartDiscountEl.getAttribute('data-active-discount-code');
    }
    if (discountCode) {
      try {
        var url = new URL(checkoutBtn.href, window.location.origin);
        if (!url.searchParams.has('discount')) {
          url.searchParams.set('discount', discountCode);
          checkoutBtn.href = url.pathname + url.search;
        }
      } catch (err) {}
    }

    // Find the enclosing footer/summary container
    var wrapper = checkoutBtn.closest('.cart-drawer__footer, .cart-summary');
    if (!wrapper) return;

    var checkbox = wrapper.querySelector('.js-cart-agree-checkbox');
    if (!checkbox) return;

    if (!checkbox.checked) {
      e.preventDefault();
      
      var warning = wrapper.querySelector('.cart-agreement-warning');
      if (warning) {
        warning.style.display = 'block';
        setTimeout(function() {
          warning.style.display = 'none';
        }, 4000);
      }
    }
  });
});
